import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamPill, UserPill } from 'components/Pill';
import InlineList from 'components/InlineList';
import { jsx as _jsx } from "react/jsx-runtime";
function TeamsAndUsersList(_ref) {
  var onRemoveTeam = _ref.onRemoveTeam,
    onRemoveUser = _ref.onRemoveUser,
    teams = _ref.teams,
    users = _ref.users;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(InlineList, {
    spacing: "xxs",
    children: [].concat(_toConsumableArray(teams.map(function (team) {
      var id = team.id,
        name = team.name;
      var deleteProps = onRemoveTeam ? {
        onDelete: function onDelete() {
          return onRemoveTeam(id);
        },
        deleteLabel: t('actions_remove_team', {
          name: name
        })
      } : {};
      return /*#__PURE__*/_jsx(TeamPill, _objectSpread({
        team: team
      }, deleteProps), id);
    })), _toConsumableArray(users.map(function (user) {
      var id = user.id,
        name = user.name;
      var deleteProps = onRemoveUser ? {
        onDelete: function onDelete() {
          return onRemoveUser(id);
        },
        deleteLabel: t('actions_remove_user', {
          name: name
        })
      } : {};
      return /*#__PURE__*/_jsx(UserPill, _objectSpread({
        user: user
      }, deleteProps), id);
    })))
  });
}
export default TeamsAndUsersList;